/* src/app/main/claim-data/list/claim-data.component.scss */
:host ::ng-deep pageable-table td:nth-child(3) {
  white-space: pre-line;
  vertical-align: top;
}
/*# sourceMappingURL=claim-data.component-ECJ3ZVL2.css.map */
